import { Col } from "components/primitives";
import { VoiceMap, getBestVoice } from "components/utils/voiceMap";
import { DashboardContext } from "contexts/DashboardContext";
import React, { FC, useContext, useEffect } from "react";
import Form from "react-bootstrap/esm/Form";
import styled from "styled-components";
import { VoiceType } from "types/GlobalData";

import { SegmentProps } from "./ToolbarContainer";
import { ToolbarSegmentHeader } from "./ToolbarSegmentHeader";

export const SoundsToolbar: FC<SegmentProps> = ({ setCurrentSegment, data, onSetData }) => {
  const { data: globalData, setData: updateGlobalData } = useContext(DashboardContext);

  useEffect(() => {
    // Warm up the voices
    speechSynthesis.getVoices();
  }, []);

  const handleChangeVoice = (event: React.ChangeEvent<HTMLInputElement>) => {
    const type = event.target.value as VoiceType;

    if (type in VoiceMap) {
      const newData = globalData.dashboardGroups
        .find((group) => group.id === globalData.activeDashboardGroupId)!
        .dashboards.map((dashboard) => {
          if (dashboard.id === globalData.activeDashboardId) {
            return {
              ...dashboard,
              voiceType: type,
            };
          }

          return dashboard;
        });

      const newGroups = [...globalData.dashboardGroups];
      newGroups.find((group) => group.id === globalData.activeDashboardGroupId)!.dashboards =
        newData;

      updateGlobalData({
        dashboardGroups: newGroups,
      });
      onSetData({
        ...data,
        voiceType: type,
      });

      const selectedVoice = getBestVoice(type);

      if (selectedVoice) {
        const utterence = new SpeechSynthesisUtterance("New voice selected");
        utterence.voice = selectedVoice;

        speechSynthesis.speak(utterence);
      } else {
        speechSynthesis.speak(new SpeechSynthesisUtterance("No suitable voice found"));
      }
    }
  };

  return (
    <OuterContainer>
      <ToolbarSegmentHeader header="Sounds" onBack={() => setCurrentSegment("settings")} />
      <Form.Label>Read Aloud Voice</Form.Label>

      <Form.Control as="select" value={data.voiceType} onChange={handleChangeVoice}>
        {Object.keys(VoiceMap).map((type, index) => (
          <option key={index} selected={type === data.voiceType}>
            {type}
          </option>
        ))}
      </Form.Control>
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)`
  width: 100%;
`;
